import { render, staticRenderFns } from "./home-tabs.vue?vue&type=template&id=a62df08a&scoped=true&"
import script from "./home-tabs.vue?vue&type=script&lang=js&"
export * from "./home-tabs.vue?vue&type=script&lang=js&"
import style0 from "./home-tabs.vue?vue&type=style&index=0&id=a62df08a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62df08a",
  null
  
)

export default component.exports